<template>
  <div class="agreement">
    <div class="wrap">
      <!--str:主体-->
      <div class="wrapConOut">
        <div class="wrapCon">
          <a href="/" class="passLogo">用户中心</a>
          <div class="backHomeBox">
            <a href="http://www.huanqiu.com/" class="backHome">环球网首页</a>|
            <a href="https://www.huanqiu.com/sitemap" class="webMap">网站地图</a>
          </div>
          <div class="mailActCon">
            <div class="mailActConInner">
              <div class="gateHd">《环球网用户条款及隐私协议》</div>
              <div class="agreeMentBox">
                <div class="agreeMentArea">
                  <strong>一、环球网用户服务条款</strong>
                  <br />
                  <br />
                  <strong>1. 环球网服务条款的确认和接受</strong>
                  <br />
                  <br />环球网的各项网络服务的所有权和运营权归环球时报在线（北京）文化传播有限公司（以下简称"环球网"）所有。环球网依照本服务条款及其不时发布的操作规则提供网络服务，此外，用户使用环球网各项分类服务时，用户应当仔细阅读、理解、自愿同意接受本服务条款的全部内容并遵守与该项服务相关的规则与要点。用户必须完全同意所有服务条款并完成注册程序，才能成为环球网的正式用户。
                  <br />
                  <br />
                  <strong>2. 服务说明</strong>
                  <br />
                  <br />环球网仅为用户提供网络服务。用户必须自行配备上网的所需设备（如个人电脑、手机、调制解调器或其他必备上网装置）及所需费用（如上网所支付的与此服务有关的电话费用、 网络费用、手机费用等）。
                  基于环球网所提供的服务的重要性，用户应同意：
                  <br />
                  <br />（1）提供详尽、准确的个人资料。
                  <br />
                  <br />（2）不断更新注册资料，符合及时、详尽、准确的要求。
                  <br />
                  <br />
                  <strong>3. 网上注册</strong>
                  <br />
                  <br />用户在申请使用环球网网络服务时，必须向环球网提供准确的个人资料，如个人资料有任何变动，必须及时更新。用户一旦注册成功，成为环球网的合法用户，将得到一个密码和用户名。每个用户应当对以其用户名进行的所有活动和事件承担全部责任。
                  <br />
                  <br />用户在此同意接受环球网通过电子邮件或其他方式向用户发送宣传推广或者其他相关商业信息。
                  <br />
                  <br />在不对外披露单个用户隐私资料的前提下，环球网有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
                  <br />
                  <br />
                  <strong>4. 用户名、用户密码和安全性</strong>
                  <br />
                  <br />用户将对用户名和密码安全承担全部责任。用户可随时根据提示改变用户的密码。用户不应将其账号、密码转让或出借予他人使用。如用户发现其账号遭他人非法使用或存在安全漏洞的情况，应立即通知环球网。因黑客行为或用户的保管疏忽导致账号、密码遭他人非法使用，环球网不承担任何责任。
                  <br />
                  <br />如用户注册的免费网络服务的账号在任何连续180日内未实际使用，或者用户注册的收费网络服务的账号在其订购的收费网络服务的服务期满之后连续180日内未实际使用，则环球网有权删除该账号并停止为该用户提供相关的网络服务。
                  <br />
                  <br />
                  <strong>5. 用户隐私制度（详细请见《环球网隐私权保护政策》）</strong>
                  <br />
                  <br />
                  <strong>6. 对用户发布信息的的管理</strong>
                  <br />
                  <br />用户在本环球网发布信息时，必须遵守国家有关法律规定，并承担一切因自己发布信息不当导致的民事、行政或刑事法律责任。用户在在环球网所发布的信息，不得含有以下内容：
                  <br />
                  <br />(1)违反宪法确定的基本原则的；
                  <br />
                  <br />(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                  <br />
                  <br />(3)损害国家荣誉和利益，攻击党和政府的；
                  <br />
                  <br />(4)煽动民族仇恨、民族歧视，破坏民族团结的；
                  <br />
                  <br />(5)破坏国家、地区间友好关系的；
                  <br />
                  <br />(6)违背中华民族传统美德、社会公德、论理道德、以及社会主义精神文明的；
                  <br />
                  <br />(7)破坏国家宗教政策，宣扬邪教和封建迷信的；
                  <br />
                  <br />(8)散布谣言或不实消息，扰乱社会秩序 ，破坏社会稳定的；
                  <br />
                  <br />(9)煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的；
                  <br />
                  <br />(10)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
                  <br />
                  <br />(11)侮辱或诽谤他人，侵害他人合法权益的；
                  <br />
                  <br />(12)侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的；
                  <br />
                  <br />(13)使用漫骂、辱骂、中伤、恐吓、诅咒等不文明语言的；
                  <br />
                  <br />(14)以非法民间组织名义活动的；
                  <br />
                  <br />(15)含有法律、行政法规禁止的其他内容的
                  <br />
                  <br />如果用户在环球网发布信息时，不能履行和遵守协议中的规定，为维护本网站的形象、信誉、安全、本网站有权删除用户发布的信息。并对违反协议的用户做出封闭ID，暂时、永久禁止在本网站发布信息的处理。同时保留依法追究当事人法律责任的权利。
                  <br />
                  <br />用户需独立对自己在网上的行为承担法律责任。若用户的行为不符合上述服务条款，环球网有权做出独立判断立即取消用户服务账号，用户若在环球网上散布和传播反动、色情或其他违反国家法律的信息，环球网的系统记录有可能作为用户违反法律的证据。
                  <br />
                  <br />环球网不对用户所发布信息的删除或储存失败承担任何责任。环球网有权判定用户的行为是否符合中国法律法规的规定以及环球网服务条款的要求，如果用户违背了中国法律法规的规定或服务条款的规定，环球网有中断对其提供服务的权利。 对于用户通过环球网络技术服务（包括但不限于论坛、新闻评论、博客、图片等频道）上传到环球网上可公开获取区域的任何内容，用户同意授予环球网在全世界范围内永久性的、不可撤销的、免费的、非独家的和再许可的权利和许可，环球网可以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示该等内容的全部或部分，和/或将此等内容的全部或部分编入其他任何形式的作品、媒体或技术中。
                  <br />
                  <br />
                  <strong>7. 网络服务内容的所有权</strong>
                  <br />
                  <br />环球网定义的网络服务内容包括：环球网提供的文字、软件、声音、图片、录象、图表、广告中的全部内容、电子邮件的全部内容以及环球网为用户提供的其他信息。所有这些内容受版权、商标和/或其它财产所有权法律的保护。所以，用户只能在环球网和相关权利人授权下才能使用这些内容，而不能擅自复制、发布、转载、播放、改编、汇编或以其他方式使用这些内容或将该等内容用于其他任何商业目的。
                  <br />
                  <br />
                  <strong>8. 链接</strong>
                  <br />
                  <br />环球网站内设有通往其他网站和网页的链接，但这些网站和网页并非由环球网经营或控制，环球网不承担责任。用户启动任何此类链接或网页，离开环球网站进入其他网站或网页，所有风险自负，环球网不承担一切责任和债务。
                  <br />
                  <br />
                  <strong>9.免责声明</strong>
                  <br />
                  <br />用户同意对环球网网络服务的使用承担全部风险，并对因其使用环球网络服务而产生的一切后果承担全部风险，环球网对用户不作任何类型的担保，也不承担任何责任。 环球网不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对服务的及时性、安全性、准确性都不作担保。 对于因不可抗力或环球网不能避免或控制的原因造成的网络服务中断或其它缺陷，环球网不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
                  <br />
                  <br />
                  <strong>10.损害赔偿责任</strong>
                  <br />
                  <br />用户同意保障和维护环球网及其他用户的利益，如因用户违反有关法律、法规或本服务条款的任何条款而给环球网或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。 环球网对用户使用网络服务所产生的任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务、在网上购买商品或进行同类型服务、在网上进行交易、非法使用网络服务或用户传送的信息有所变动。
                  <br />
                  <br />
                  <strong>
                    11. 如果您是环球网内某一作品的著作权人和/或依法可以行使信息网络传播权的权利人，且您认为环球网站上注册用户上传的内容侵犯了您对该等作品的信息网络传播权，请您务必书面通知贵公司，您应对书面通知陈述之真实性负责。
                    为方便本公司及时处理您之意见，您的通知书中应建议包含以下内容：
                  </strong>
                  <br />
                  <br />您的名称（姓名）、联系方式及地址；
                  <br />
                  <br />要求删除的作品的名称和在本网站的地址；
                  <br />
                  <br />构成侵权地初步证明材料，谨此提示以下材料可能构成初步证明：
                  <br />
                  <br />对于涉嫌侵权作品拥有著作权或依法可以行使信息网络传播权的权属证明；
                  <br />
                  <br />对涉嫌侵权作品侵权事实的举证。
                  <br />
                  <br />您的签名及身份证明文件。
                  <br />
                  <br />请您将该等通知及材料投寄以下地址：
                  <br />
                  <br />北京市朝阳区东三环北路19号中青大厦16层
                  <br />
                  <br />法务收
                  <br />
                  <br />邮政编码：100020
                  <br />
                  <br />一旦收到符合上述要求之通知，我们采取包括删除等相应措施。如不符合上述条件，我们会请您提供相应信息，且暂不采取包括删除等相应措施。
                  <br />
                  <br />在环球网上载作品的用户视为同意环球网就前款情况所采用的相应措施。环球网不因此而承担任何违约责任或其他任何法律责任。环球网在收到上述通知后会通知上载该等作品的用户。
                  <br />
                  <br />
                  <strong>12.服务的变更、中断或终止</strong>
                  <br />
                  <br />鉴于网络服务的特殊性，环球网有权随时变更或中断或终止部分或全部网络服务，不需对用户或第三方负责。
                  <br />
                  <br />为了网站的正常运行，环球网定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护而造成网络服务的中断，环球网将尽力避免服务中断或将中断时间限制在最短时间内，在合理时间内的服务中断，环球网无需为此承担任何责任。
                  <br />
                  <br />如发生下列任何一种情形，环球网有权随时中断或终止向用户提供网络服务（包括收费网络服务）而无需对用户或任何第三方承担任何责任：
                  <br />
                  <br />（1） 用户提供的资料不真实；
                  <br />
                  <br />（2） 用户违反本服务条款的有关规定；
                  <br />
                  <br />（3） 用户在使用收费网络服务时未按规定向环球网支付相应的服务费。
                  <br />
                  <br />
                  <strong>13．服务条款的变更和修订</strong>
                  <br />
                  <br />环球网有权随时对服务条款进行修改，并且一旦发生服务条款的变动，环球网将在页面上提示修改的内容；当用户使用环球网的特殊服务时，应接受环球网随时提供的与该特殊服务相关的规则或说明，并且此规则或说明均构成本服务条款的一部分。用户如果不同意服务条款的修改，可以主动取消已经获得的网络服务；如果用户继续享用网络服务，则视为用户已经接受服务条款的修改。环球网保留不时地且不需通知用户而升级或更改本"提交协议"和所有有关参考文件的权利。
                  <br />
                  <br />
                  <strong>14.适用法律</strong>
                  <br />
                  <br />本服务条款的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。如本服务条款与中华人民共和国法律相抵触时，则该等条款将按法律规定重新修订，而其它条款则依旧有效并具有法律效力。 如双方就本服务条款内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向环球网所在地的人民法院提起诉讼。
                  <br />
                  <br />
                  <strong>15.青少年用户特别提示</strong>
                  <br />
                  <br />青少年用户必须遵守全国青少年网络文明公约：
                  <br />
                  <br />要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。
                  <br />
                  <br />
                  <strong>16. .其他规定</strong>
                  <br />
                  <br />本服务条款中的标题仅为方便而设，在解释本服务条款时应被忽略，环球网保留进一步修改本服务条款的权利。
                  <br />
                  <br />
                  <strong>二、隐私权保护政策</strong>
                  <br />
                  <br />环球网尊重并保护使用环球的用户个人隐私权。"隐私"是指用户在注册使用环球网服务时提供给环球网的个人身份信息，包括用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等用户信息。为了给用户提供更及时、准确、便捷及个性化的服务，环球网会按照本隐私保护政策的规定使用和披露用户信息。同时，环球网将以高度的勤勉审慎义务对待用户信息。本隐私权保护政策属于环球网用户服务协议不可分割的一部分。在使用环球网提供的服务前，请用户仔细阅读以下隐私权保护政策。
                  <br />
                  <br />
                  <strong>用户信息</strong>
                  <br />
                  <br />环球网为用户提供对个人注册信息的绝对的控制权，用户在注册时提供的所有信息，都是基于自愿，用户有权在任何时候拒绝提供这些信息。用户可以通过"修改个人信息"查看或修改个人信息。
                  <br />
                  <br />
                  <strong>用户信息安全</strong>
                  <br />
                  <br />环球网将对用户所提供的信息进行严格的管理及保护，环球网通过技术手段、提供隐私保护服务功能、强化内部管理等办法充分保护用户的个人信息安全。同时，环球网将通过向其它服务器备份、对用户密码进行加密等安全措施确保用户信息尽可能不丢失，不被滥用和变造。尽管有前述安全措施，也必须提示用户注意在信息网络上不存在"完美的安全措施"。
                  <br />
                  <br />
                  <strong>用户信息披露</strong>
                  <br />
                  <br />环球网保证不对外公开或向第三方提供用户注册的个人信息，包括用户在使用服务时存储的非公开内容，但下列情况除外：
                  <br />
                  <br />根据有关法律法规的要求；
                  <br />
                  <br />按照相关政府主管部门的要求；
                  <br />
                  <br />维护社会个体和公众的安全；
                  <br />
                  <br />为维护社会公共利益的需要；
                  <br />
                  <br />维护本网站的合法权益；
                  <br />
                  <br />事先获得用户的明确授权；
                  <br />
                  <br />符合其他相关的要求；
                  <br />
                  <br />Cookies技术的使用
                  <br />
                  <br />4.1 Cookies是指一种技术，当用户访问设有Cookies装置的环球网时，环球网之服务器会自动发送Cookies至用户浏览器内，并储存到用户的电脑硬盘内，此Cookies便负责记录日后该用户到访环球网的种种活动、个人资料、浏览习惯、消费习惯等。
                  <br />
                  <br />4.2 运用Cookies技术，环球网能够为用户提供更加细致的个性化服务。环球网将会运用Cookies追访您的阅读喜好，从而向用户提供感兴趣的信息资料或储存密码，以便用户造访环球网时不必每次重复输入密码。
                  环球网可能会不时修改我们的隐私权保护政策，这些修改会反映在本政策中。任何修改都会将用户的满意度及政策的合法性置于重要位置。环球网鼓励用户在每次访问环球网的网页时都查阅我们的隐私权保护政策。
                  有关环球网的隐私权保护政策有任何意见或建议，请通过电话、传真或邮件直接与环球网客户服务部门联系。
                  <br />
                  <br />
                </div>
                <div class="btn">
                  <span class="blueBtn" @click="isMobileFn()">我已阅读</span>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
              <div class="footer-link">
                  <a target="_blank" href="http://corp.huanqiu.com/about/">环球网简介</a>
                  <b>|</b>
                  <a target="_blank" href="https://corp.huanqiu.com/aboutus/">About huanqiu.com</a>
                  <b>|</b>
                  <a target="_blank" href="https://www.huanqiu.com/sitemap">网站地图</a>
                  <b>|</b>
                  <a target="_blank" href="http://corp.huanqiu.com/jobs/">诚聘英才</a>
                  <b>|</b>
                  <a target="_blank" href="http://corp.huanqiu.com/advertising_services/">广告服务</a>
                  <b>|</b>
                  <a target="_blank" href="http://corp.huanqiu.com/contactus/">联系方式</a>
                  <b>|</b>
                  <a target="_blank" href="http://corp.huanqiu.com/privacy_policy/">隐私政策</a>
                  <b>|</b>
                  <a target="_blank" href="http://corp.huanqiu.com/terms/">服务条款</a>
                  <b>|</b>
                  <a target="_blank" href="mailto:jubao@huanqiu.com">意见反馈</a>
                  <b>|</b>
                  <a href="//www.huanqiu.com/globaltimes" target="_blank">环球时报系产品</a>
              </div>
              <div class="copyright">© 环球网 版权所有</div>
          </div>
            
        </div>
      </div>
      <!--end:主体-->
    </div>
  </div>
</template>
<script>
export default {
  name: "agreement",
  data() {
    return {
      form: {}
    };
  },
  methods: {
    isMobileFn() {
      if (this.isMobile) {
        this.$router.push({
          name: "mregister",
          agreeStatus: true,
          params: { registForm: this.$route.params.registForm }
        });
      } else {
        window.close();
      }
    }
  }
  // created(){
  //   if (this.$router.params.registForm) {
  //     this.form
  //   }
  // }
};
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
img {
  border: none;
}
a {
  text-decoration: none;
  color: #252525;
}
a:hover {
  text-decoration: underline;
  color: #d00005;
}
h5 {
  font-weight: normal;
}
h5 em {
  font-style: normal;
  color: #93090f;
  margin: 0 5px;
  display: inline-block;
}
h5 em a {
  color: #93090f;
  margin: 0 2px;
}
em,
i {
  font-style: normal;
}
.algCen {
  text-align: center;
}
input {
  outline: none;
}

.agreement {
  background: url("../../assets/images/topRep.png") repeat-x;
  background-color: #eeeeee;
}

.backHome {
  margin: 0 12px 0 0;
}

.wrap {
  background: url("../../assets/images/cloud.jpg") no-repeat center 125px;
}

.wrap {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  min-height: 700px;
}

.wrapConOut {
  width: 970px;
  min-height: 750px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.wrapCon {
  width: 970px;
  overflow: hidden;
  margin-top: 8%;
  position: relative;
}

.passLogo,
.regBtn,
.verifyInput,
.regInpTxt,
.inputWrong,
.verifyShow,
.logBtn,
.blueBtn {
  background: url("../../assets/images/gatePass.png") no-repeat;
}

.passLogo {
  position: absolute;
  left: 5px;
  top: 5px;
  width: 210px;
  height: 43px;
  background-position: 0 0;
  text-indent: -9999px;
}

.backHomeBox {
  position: absolute;
  right: 0px;
  top: 30px;
  display: block;
  width: 210px;
  height: 18px;
  color: #cacaca;
  font-size: 14px;
  text-align: right;
  padding-right: 10px;
}

.backHome,
.webMap {
  display: inline-block;
  background-position: 0 0;
  text-align: right;
  color: #4c99e8;
  font-size: 14px;
  line-height: 18px;
}

.webMap {
  margin: 0 0 0 6px;
}

.mailActCon {
  background: url("../../assets/images/gateBottom.jpg") no-repeat left bottom;
}

.mailActCon {
  width: 970px;
  margin: 80px auto 25px auto;
  background-color: #fff;
}

.mailActConInner {
  width: 970px;
  height: 560px;
  overflow: hidden;
  position: relative;
}

.gateHd {
  background: url("../../assets/images/topBg.jpg") no-repeat;
}

.gateHd {
  width: 100%;
  height: 70px;
  overflow: hidden;
  color: #fff;
  font-size: 29px;
  text-align: center;
  line-height: 70px;
}

.agreeMentBox {
  margin: 30px 40px;
}

.agreeMentArea {
  width: 890px;
  height: 360px;
  line-height: 30px;
  overflow-x: hidden;
  overflow-y: scroll;
  font-size: 14px;
  color: #2b2b2b;
}

.regBtn,
.blueBtn {
  border: none;
  display: inline-block;
  width: 220px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  background-position: 0 -70px;
  clear: both;
  margin-left: 0px;
  float: left;
  margin-left: 100px;
  margin-top: 30px;
}

.agreeMentBox .blueBtn {
  margin-left: 330px;
}

.agreeMentBox .blueBtn:hover {
  border: none;
  display: inline-block;
  width: 220px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  clear: both;
  margin-left: 330px;
  float: left;
  margin-top: 30px;
  background: url("../../assets/images/gatePass.png") no-repeat 0 -70px !important;
  box-shadow: unset !important;
}

/* 页尾 */

.footer {
    margin: 0 auto;
    width: 1000px;
    height: 53px;
    padding-bottom: 27px;
    // background: #ffffff;
}

.footer .footer-link {
    text-align: center;
    overflow: hidden;
    color: #919191;
    height: 26px;
    line-height: 34px;
    font-size: 12px;
}

.footer .footer-link a {
    color: #919191;
    text-decoration: none;
}

.footer .footer-link a:active,
.footer .footer-link a:hover {
    background: 0 0;
    text-decoration: underline;
}

.footer .footer-link b {
    padding: 0 10px;
    font-weight: 400;
}

.footer .copyright {
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    color: #919191;
    height: 26px;
    line-height: 34px;
    font-size: 12px;
}
.foot {
  width: 970px;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
}

.fLink {
  height: 37px;
  text-align: center;
  color: #b0b0b0;
  font-size: 14px;
}

.flinkMain {
  width: 960px;
  margin: 0 auto;
  height: 35px;
  line-height: 38px;
}

.fLink a {
  color: #b0b0b0;
  text-decoration: none;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  margin: 0 10px;
  font-family: "宋体";
}

.copyMain {
  width: 950px;
  margin: 0 auto;
  text-align: center;
  color: #b0b0b0;
}

.copyMain em {
  margin-left: 50px;
  font-style: normal;
  font-size: 12px;
}

.copyMain a {
  color: #b0b0b0;
  margin: 0 5px;
  display: inline-block;
  font-size: 12px;
}

strong {
  font-weight: unset;
}
@media only screen and (max-width: 767px) {
  strong {
    font-weight: bolder;
  }

  .agreement {
    background: #f5f5f5 url("../../assets/images/magreement.png") repeat-x;
    background-size: 100%;
  }

  .wrap,
  .wrapConOut,
  .agreeMentArea {
    height: 100%;
    min-height: 100%;
  }

  .agreeMentArea {
    font-size: 9px;
    line-height: 15px;
    text-align: justify;
    color: #4c4c4c;
  }

  .wrapConOut,
  .wrapCon,
  .mailActCon,
  .mailActConInner,
  .agreeMentArea {
    width: 100%;
  }

  .wrap {
    background: unset;
  }

  .wrapCon {
    margin-top: 100px;
  }

  .agreeMentBox {
    margin: 30px 30px;
  }

  .mailActCon {
    background: unset;
    margin: 0 auto;
  }

  .mailActConInner {
    height: 100%;
  }

  .backHomeBox,
  .passLogo,
  .gateHd,
  .footer {
    display: none;
  }

  .agreeMentBox .blueBtn {
    margin: 0 auto;
    float: unset;
    width: 75px;
    height: 30px;
    font-size: 13px;
    line-height: 30px;
  }

  .agreeMentBox .blueBtn:hover {
    border: none;
    display: inline-block;
    width: 75px;
    height: 30px;
    line-height: 30px;
    border-radius: 3px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    cursor: pointer;
    clear: both;
    float: unset;
    margin: 0 auto;
    background: unset;
    box-shadow: unset !important;
  }

  .btn {
    margin: 0 auto;
    width: 100%;
    text-align: center;
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agreement/index.vue